import { Space } from 'antd'
import { CIMSTags } from 'components/CIMSTags'
import { ImplicitPermissions } from './useImplicitPermissions/types'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'

export const useFDCGroupsPanel = ({
  fdcApprovalGroups,
  fdcConcurrenceGroups,
}: Pick<
  ImplicitPermissions,
  'fdcApprovalGroups' | 'fdcConcurrenceGroups'
>): CIMSCollapsePanelOptions[] =>
  !!fdcApprovalGroups.length || !!fdcConcurrenceGroups.length
    ? [
        {
          key: `fdc-groups-${Math.random()}`,
          header: 'Field Design Changes',
          children: (
            <Space direction="vertical" size="small">
              {!!fdcApprovalGroups.length && (
                <>
                  {'Approval Groups:'}
                  <CIMSTags
                    tags={fdcApprovalGroups.map(({ name, description }) => ({
                      text: name,
                      tooltip: description,
                    }))}
                  />
                </>
              )}
              {!!fdcConcurrenceGroups.length && (
                <>
                  {'Concurrence Groups:'}
                  <CIMSTags
                    tags={fdcConcurrenceGroups.map(({ name, description }) => ({
                      text: name,
                      tooltip: description,
                    }))}
                  />
                </>
              )}
            </Space>
          ),
        },
      ]
    : []
